import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldOff, ArrowLeft } from 'lucide-react';

export default function AccessDenied() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-soem-bg flex items-center justify-center">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <ShieldOff size={40} className="text-red-600" />
        </div>
        <h1 className="text-3xl font-black text-soem-navy mb-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Acceso denegado
        </h1>
        <p className="text-slate-500 mb-8">
          No tienes los permisos necesarios para acceder a esta sección.
        </p>
        <button
          onClick={() => navigate(-1)}
          className="soem-btn-secondary px-6 py-2.5 flex items-center gap-2 mx-auto"
          data-testid="back-btn"
        >
          <ArrowLeft size={16} />
          Volver atrás
        </button>
      </div>
    </div>
  );
}
